import { useEffect, useRef, useState } from "react";
import connection_socket from "../../config/connection_socket";
import { customAlphabet } from "nanoid";
import axios from "../../config/axios";
import { useTV } from "../../hooks/useTV";

const DisplayConnection = ({ setRefresh, started, setStarted, deviceID }) => {
  const [device_id] = useState(customAlphabet("1234567890", 6)());
  const [success, setSuccess] = useState(false);
  const audioRef = useRef();
  const { isTv } = useTV();

  const handleSuccessfulConnection = () => {
    setSuccess(true);
    audioRef.current.volume = localStorage.getItem("volume");
    audioRef.current.play();

    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  useEffect(() => {
    let client_identifier = localStorage.getItem("client_identifier");
    if (!client_identifier) {
      client_identifier = customAlphabet(
        "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        15
      )();
      localStorage.setItem("client_identifier", client_identifier);
    }

    // start polling for connection status
    const polling = setInterval(() => {
      axios
        .get(`/users/device/connection`, {
          withCredentials: true,
          params: {
            code: device_id,
            client_identifier: client_identifier,
          },
        })
        .then((response) => {
          console.log(response.data.connection.connected);
          if (response.data.connection.connected) {
            clearInterval(polling);
            localStorage.setItem(
              "device_data",
              JSON.stringify(response.data.device)
            );
            handleSuccessfulConnection();
          }
        });
    }, 2500);

    //emitting an event to the server with a unique id to identify the display
    connection_socket.emit("display_send_init_connection", {
      device_id: device_id,
      client_identifier: client_identifier,
      device_type: isTv ? "TV" : "display",
    });

    //listening for an event from the server which is
    // sent when the right code is entered in the remote application
    connection_socket.on("display_listen_device_connection", (data) => {
      // console.log(data);
      // localStorage.setItem("device_data", JSON.stringify(data));
      // setRefresh(Math.random());
      //   handleSuccessfulConnection();
    });

    return () => {
      clearInterval(polling);
    };
  }, []);

  // Background image styles
  const connectionBgStyle = isTv
    ? {
        position: "absolute",
        top: "-115px",
        left: "0px",
        width: "100%",
        height: "auto",
        objectFit: "cover",
        zIndex: "0",
        opacity: success ? "0" : "1",
        transition: "opacity 2s",
      }
    : {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        zIndex: "-1",
        opacity: success ? "0" : "1",
        transition: "opacity 2s",
      };

  // Device ID container styles
  const deviceIdContainerStyle = isTv
    ? {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "4px",
        position: "absolute",
        left: "52.0%",
        top: "34%",
        zIndex: 3,
        opacity: success ? "0" : "1",
      }
    : {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "4px",
        position: "absolute",
        left: "51.5%",
        top: "39%",
        zIndex: 3,
        opacity: success ? "0" : "1",
      };

  // Device ID text styles
  const deviceIdTextStyle = isTv
    ? {
        fontSize: "95px",
        fontWeight: "800",
        color: "#012f51",
        fontFamily: "Lato",
        transform: "rotate(14deg)",
      }
    : {
        fontSize: "70px",
        fontWeight: "800",
        letterSpacing: "wider",
        color: "#012f51",
        fontFamily: "Lato",
        transform: "rotate(14deg)",
      };

  // Success background image styles
  const connection2BgStyle = isTv
    ? {
        position: "absolute",
        top: "-115px",
        left: "0px",
        width: "100%",
        height: "auto",
        objectFit: "cover",
        zIndex: "0",
        opacity: success ? "1" : "0",
        transition: "opacity 2s",
      }
    : {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        zIndex: "0",
        opacity: success ? "1" : "0",
        transition: "opacity 2s",
      };

  // Connection background overlay styles
  const connectionBgOverlayStyle = isTv
    ? {
        position: "absolute",
        top: "-50px",
        left: "0px",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        zIndex: "2",
        opacity: success ? "1" : "0",
      }
    : {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        zIndex: "2",
        opacity: success ? "1" : "0",
      };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        position: "relative",
      }}
    >
      <audio
        src="https://cdn.mywaitserver.live/connection-chime.mp3"
        ref={audioRef}
      ></audio>
      {!deviceID && (
        <img style={connectionBgStyle} src="/static/connection-1.png" alt="" />
      )}

      <img style={connection2BgStyle} src="/static/connection-2.png" alt="" />
      <img
        style={connectionBgOverlayStyle}
        src={isTv ? "/static/connection-bg2.png" : "/static/connection-bg.png"}
        alt=""
      />

      <div
        style={deviceIdContainerStyle}
        // onClick={handleSuccessfulConnection}
      >
        {/*<span style={{ fontSize: '32px', fontWeight: '600', textTransform: 'uppercase', color: '#ffffff', }}>Your Device ID</span>*/}
        <span style={deviceIdTextStyle}> {device_id} </span>
      </div>

      <button
        onClick={() => {
          window.location.reload();
        }}
        style={{
          width: "auto",
          height: isTv ? "100px" : "80px",
          background: "white",
          borderRadius: "20px",
          paddingLeft: "30px",
          paddingRight: "30px",
          fontSize: "25px",
          position: "absolute",
          right: "5%",
          top: "17%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 5,
          fontFamily: "Lato",
          backgroundColor: "var(--color-primary)",
          color: "white",
          border: "none",
          cursor: "pointer",
          fontWeight: "600",
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        New Room #
      </button>
    </div>
  );
};

export default DisplayConnection;
